import React, { createContext } from 'react';
import { CombinedWidgetContent, HookListType, WidgetStateProps } from 'jamespot-user-api';

export type HookIsActive = (name: keyof HookListType) => boolean | undefined;
export type OnError = (message: string) => void;
export type OnStateChange = (state: WidgetStateProps) => void;
export type OnChange<T> = (content: Partial<T>, override?: boolean) => void;
export type OnSave<T> = (content: Partial<T>) => void;

export type Handlers = {
    handleStart: () => void;
    handleCatch: (reason: any) => void;
    handleFinally: () => void;
};

export type EditorBaseContext<T = CombinedWidgetContent> = {
    hook?: {
        isActive: HookIsActive;
    };
    onStateChange: OnStateChange;
    onChange: OnChange<T>;
    onSave: OnSave<T>;
    onError: OnError;
};

export const EditorContainerContext = <T,>() => {
    return createContext<T | null>(null);
};

export const ContainerContext = EditorContainerContext();

export const EditorContainerProvider = <T,>(props: { children: React.ReactNode } & T) => {
    return <ContainerContext.Provider value={props}>{props.children}</ContainerContext.Provider>;
};
